export default "__VITE_ASSET__COH0mYFA__"